import React from "react"
import { Select, MenuItem } from '@mui/material';

export const PageSizeSelect = ({ value, onChange }) => {
    return (
        <Select
                variant="standard"
                size="small"
                value={value}
                onChange={(event) => onChange(event.target.value)}
            >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
        </Select>
    );
}
